import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Logo from "../Images/Qualified-Stucco-logo.png";
import "../Styles/Navbar.css";

function Navbar() {
  const [nav, setNav] = useState(false);

  const openNav = () => setNav(!nav);

  return (
    <nav className="navbar-section">
      <div className="navbar-inner">
        <div className="navbar-logo">
          <Link to="/">
            <img src={Logo} alt="Qualified Stucco Drywall" className="navbar-logo-img" />
          </Link>
        </div>

        <ul className="navbar-items">
          <li><Link to="/" className="navbar-links">Home</Link></li>
          <li><Link to="/services" className="navbar-links">Services</Link></li>
          <li><Link to="/about" className="navbar-links">About Us</Link></li>
          <li><Link to="/blog" className="navbar-links">Blog</Link></li>
          <li><Link to="/contact-us" className="navbar-links">Contact</Link></li>
        </ul>

        <Link to="/contact-us" className="navbar-btn">Get A Quote</Link>

        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar-close">
            <FontAwesomeIcon icon={faXmark} className="hamb-icon" />
          </div>
          <ul className="mobile-navbar-links">
            <li><Link onClick={openNav} to="/">Home</Link></li>
            <li><Link onClick={openNav} to="/services">Services</Link></li>
            <li><Link onClick={openNav} to="/about">About Us</Link></li>
            <li><Link onClick={openNav} to="/blog">Blog</Link></li>
            <li><Link onClick={openNav} to="/contact-us">Contact</Link></li>
          </ul>
        </div>

        <div className="mobile-nav">
          <FontAwesomeIcon icon={faBars} onClick={openNav} className="hamb-icon" />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
